export const ADDBOOK = "book/addbook";
export const LOADED = "book/loaded";
export const DELETED = "book/deleted";
export const TOGGLEFEATURED = "book/togglefeatured";
